"use client";

import { useEffect, useRef } from "react";
import { trackViewContent } from "@/lib/facebook-pixel";

interface ViewContentTrackerProps {
  contentName: string;
  contentCategory?: string;
}

/**
 * Component that fires Facebook Pixel ViewContent event on mount.
 * Used on landing pages to track user interest.
 */
export function ViewContentTracker({
  contentName,
  contentCategory = "landing_page",
}: ViewContentTrackerProps) {
  const hasTracked = useRef(false);

  useEffect(() => {
    // Only track once per component mount
    if (hasTracked.current) return;
    hasTracked.current = true;

    trackViewContent({
      content_name: contentName,
      content_category: contentCategory,
    });
  }, [contentName, contentCategory]);

  // This component doesn't render anything
  return null;
}
